import {
    TimelineConnector,
    TimelineContent,
    TimelineItemElement,
    TimelineOppositeContent,
} from "../TimelineItem.styles";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import { GameStateChangedTitle, TimelineEnd } from "../GameTimeline.styles";
import React from "react";

export function MatchStartedEvent() {
    return (
        <TimelineItemElement>
            <TimelineOppositeContent />
            <TimelineSeparator>
                <TimelineConnector />
                <TimelineEnd />
                <GameStateChangedTitle>Anstoß</GameStateChangedTitle>
            </TimelineSeparator>
            <TimelineContent />
        </TimelineItemElement>
    );
}
